import React, { PropsWithChildren, useCallback } from 'react';
import Surface from './Surface';
import { makeCSS } from '../../utils/makeCSS';
import { SwipeableDrawer } from '@material-ui/core';
import { Scrollbar } from '../../core/atoms/Scrollbar';
import { ContextMenuListItem } from '../../core/molecules/ContextMenu/ContextMenuListItem';
import { useRegisterMobileSurface } from './MobileSlideSurface';
import { useModalContainer } from '../../../../ui/src/Modal/ModalManagerUI';

interface MobileSubmenuSliderProps extends PropsWithChildren {
  //connects the two components states
  onClose?: () => void;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    paper: {
      borderTopLeftRadius: theme.spacing[4],
      overflowX: 'hidden',
      background: `linear-gradient(0deg, ${theme.color.overlay['02']} 0%, ${theme.color.overlay['02']} 100%), ${theme.color.background.neutral}`,
      width: '100%',
      maxHeight: '80vh',
      height: 'auto',
      top: 'auto',
      bottom: 0
    },
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyItems: 'center',
      alignItems: 'center',
      padding: theme.spacing[4],
      paddingBottom: theme.spacing[2],
      gap: theme.spacing[4],
      background: `linear-gradient(0deg, ${theme.color.overlay['02']} 0%, ${theme.color.overlay['02']} 100%), ${theme.color.background.neutral}`
    },
    drager: {
      display: 'flex',
      width: theme.spacing[1],
      height: theme.spacing[12],
      borderRadius: theme.borderRadius.full,
      background: 'rgba(255, 255, 255, 0.20)'
    },
    backButton: {
      marginLeft: '-25px'
    },
    children: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  };
});

export const MobileSubmenuSlider = (props: MobileSubmenuSliderProps) => {
  const { children, onClose } = props;

  const classes = useCSS();

  const [open, setOpen] = React.useState(true);

  const handleOpenDrawer = useCallback(
    (event: React.TouchEvent) => {
      setOpen(true);
    },
    [open]
  );
  const handleCloseDrawer = useCallback(
    (event: React.TouchEvent) => {
      if (open) {
        onClose();
        setOpen(false);
      }
    },
    [open]
  );

  const { isTopmost } = useRegisterMobileSurface();

  const container = useModalContainer();

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      classes={{ paper: classes.paper }}
      onClose={handleCloseDrawer}
      onOpen={handleOpenDrawer}
      disableSwipeToOpen={true}
      disableDiscovery
      transitionDuration={600}
      container={container}
    >
      <Surface className={`${classes.root}`} background={'transparent'}>
        <div className={`${classes.drager}`}></div>
        <div className={`${classes.children}`}>
          <span
            className={`${classes.backButton}`}
            //prevents the selected item from deseleted when back button is clicked
            data-type="librarydeselectoverride"
          >
            <ContextMenuListItem
              leftIcon="chevron_left"
              value="Back"
              showChevron={false}
              onClick={(e) => {
                e.stopPropagation();
                handleCloseDrawer(e as any);
              }}
            />
          </span>
          <Scrollbar
            colorScrollbar="dark"
            width={'100%'}
            autoHeight
            autoHeightMax={'70vh'}
          >
            {children}
          </Scrollbar>
        </div>
      </Surface>
    </SwipeableDrawer>
  );
};
